/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'app.bsky.notification.declaration'

export { $nsid }

/** A declaration of the user's choices related to notifications that can be produced by them. */
type Main = {
  $type: 'app.bsky.notification.declaration'

  /**
   * A declaration of the user's preference for allowing activity subscriptions from other users. Absence of a record implies 'followers'.
   */
  allowSubscriptions: 'followers' | 'mutuals' | 'none' | l.UnknownString
}

export type { Main }

/** A declaration of the user's choices related to notifications that can be produced by them. */
const main = l.record<'literal:self', Main>(
  'literal:self',
  $nsid,
  l.object({
    allowSubscriptions: l.string<{
      knownValues: ['followers', 'mutuals', 'none']
    }>(),
  }),
)

export { main }

export const $isTypeOf = /*#__PURE__*/ main.isTypeOf.bind(main),
  $build = /*#__PURE__*/ main.build.bind(main),
  $type = /*#__PURE__*/ main.$type
export const $assert = /*#__PURE__*/ main.assert.bind(main),
  $check = /*#__PURE__*/ main.check.bind(main),
  $cast = /*#__PURE__*/ main.cast.bind(main),
  $ifMatches = /*#__PURE__*/ main.ifMatches.bind(main),
  $matches = /*#__PURE__*/ main.matches.bind(main),
  $parse = /*#__PURE__*/ main.parse.bind(main),
  $safeParse = /*#__PURE__*/ main.safeParse.bind(main),
  $validate = /*#__PURE__*/ main.validate.bind(main),
  $safeValidate = /*#__PURE__*/ main.safeValidate.bind(main)
